import { render } from "./Workorder_XGLX.vue?vue&type=template&id=2a0864de&scoped=true"
import script from "./Workorder_XGLX.vue?vue&type=script&lang=js"
export * from "./Workorder_XGLX.vue?vue&type=script&lang=js"

import "./Workorder_XGLX.vue?vue&type=style&index=0&id=2a0864de&scoped=true&lang=less"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0864de"]])

export default __exports__